import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import '../assets/css/CustomDatePicker.css';
import ro from "date-fns/locale/ro";
import { isValid, parse } from 'date-fns';
registerLocale("ro", ro);
export default function CustomDatePicker({name, placeholder, value, onChange, ...props}) {
    const maxDate = new Date(2100, 11, 31);
    const normalizeDate = (input) => {
        if (!input) return null;
    
        if (input instanceof Date && isValid(input)) return input;
    
        if (typeof input === 'string') {
          // Try ISO format first
          const isoParsed = new Date(input);
          if (isValid(isoParsed)) return isoParsed;
    
          // Try Romanian format (dd.MM.yyyy)
          const roParsed = parse(input, "dd.MM.yyyy", new Date());
          return isValid(roParsed) ? roParsed : null;
        }
    
        return null;
      };
    
      const selectedDate = normalizeDate(value);
    return (
        <DatePicker 
            selected={selectedDate}
            onChange={date => onChange(date)} 
            placeholderText={placeholder}
            name={name}
            id={name}
            dateFormat="dd.MM.yyyy"
            locale="ro"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={maxDate}
            autoComplete="off"
            portalId="root"
            {...props}
        />
    );
}
